import styled from '@emotion/styled';
import { Colors } from '../../../colors';

export const CustomChipStyled = {
  Container: styled.div<any>`
    min-height: 21px;
    padding: 5px 10px;
    border-radius: 11px;
    background-color: ${Colors.BrightGreen};
    ${(props: any) => props.style};
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  Label: styled.p<any>`
    font-family: 'EncodeSans-Bold';
    font-size: 12px;
    color: ${Colors.White}
  `,
};
